import { InfoIcon } from '@fronton/icons-react';
import { RegularButton } from 'fronton-react';
import { Typography } from 'fronton-react/typography';
import { useUnavailableServicesBanner } from './hooks';
import { IconWrapper, InfoSection, MainContainer, TextWrapper } from './styled';
import React from 'react';

export const UnavailableServicesBanner = () => {
	const { mainServicesIsVisible, bannerTitle, onClick } = useUnavailableServicesBanner();

	return (
		<MainContainer>
			<InfoSection>
				<IconWrapper>
					<InfoIcon type="fill" size="l" color="attention-primary" data-qa="info-icon" />
				</IconWrapper>

				<TextWrapper>
					<Typography as="p" size="body_accent" variant="m" color="attention-primary">
						{bannerTitle}
					</Typography>

					{!mainServicesIsVisible && (
						<Typography as="p" size="body_long" variant="s">
							Посмотрите ниже доступные варианты
						</Typography>
					)}
				</TextWrapper>
			</InfoSection>

			{mainServicesIsVisible && (
				<RegularButton
					variant="accent"
					size="m"
					onClick={onClick}
					data-qa="available-services-button"
				>
					Доступные услуги
				</RegularButton>
			)}
		</MainContainer>
	);
};
